'use strict';

// Provides an object that keeps track of a selection for a given collection.
var ElementServiceProvider = function ElementServiceProvider() {
  function getInstance(params) {
    var selectedElement = null;
    return {
      getCollection: params.getCollection,
      createNewElement: params.createNewElement,
      preAddingNewElementHook: params.preAddingNewElementHook,
      postRemovingElementHook: params.postRemovingElementHook,
      getSelectedRowType: params.getSelectedRowType,
      getCollectionDomain: params.getCollectionDomain,
      getServiceType: params.getServiceType,
      getSelectedElement: function getSelectedElement() {
        return selectedElement;
      },
      isElementSelected: function isElementSelected(elem) {
        return elem === selectedElement;
      },
      clearSelection: function clearSelection() {
        this.selectElement(null);
      },
      selectFirstElement: function selectFirstElement() {
        var collection = this.getCollection();
        if (collection && collection.length > 0) {
          this.selectElement(collection[0]);
        } else {
          this.clearSelection();
        }
      },
      selectElement: function selectElement(elem) {
        selectedElement = elem;
      },
      resetCollection: function resetCollection() {
        var newElement = this.createNewElement();
        var collection = this.getCollection();
        collection.length = 0;
        collection.push(newElement);
        this.selectElement(newElement);
      },
      insertElement: function insertElement(newElement) {
        var collection = this.getCollection();
        var selectedElement = this.getSelectedElement();
        var insertionIndex = collection.indexOf(selectedElement);
        if (insertionIndex !== -1) {
          if (selectedElement.isEmpty()) {
            collection[insertionIndex] = newElement;
          } else {
            collection.splice(insertionIndex + 1, 0, newElement);
          }
        } else {
          if (isOneEmptyElementCollection(collection)) {
            collection[0] = newElement;
          } else {
            collection.push(newElement);
          }
        }
        this.selectElement(newElement);
      },
      isDuplicable: params.isDuplicable,
      createCopyOf: params.createCopyOf
    };
  }
  function isOneEmptyElementCollection(collection) {
    return collection.length === 1 && collection[0].isEmpty();
  }
  return {
    getInstance: getInstance
  };
};
ElementServiceProvider.$inject = [];
module.exports = ElementServiceProvider;